import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { CustomerServiceNote, CustomerServiceNoteDetail } from '@uzurv/clara';

@Component({
  selector: 'app-organization-rider-notes-detail',
  templateUrl: 'organization-rider-notes-detail.component.html',
  styleUrls: ['organization-rider-notes-detail.component.scss']
})
export class OrganizationRiderNotesDetailComponent implements OnChanges, AfterViewInit {
  @Input() customerServiceNotes: Array<CustomerServiceNoteDetail>;

  @Output() addNote = new EventEmitter<CustomerServiceNote>();

  @ViewChild('noteScrollArea', { static: true }) noteScrollArea: ElementRef;

  scrollHeight: number = null;
  newNotes = false;

  newNoteForm = this.fb.group({
    text: ['']
  });

  constructor(private cd: ChangeDetectorRef, private fb: UntypedFormBuilder) {}
  ngAfterViewInit() {
    this.scrollHeight = this.noteScrollArea ? this.noteScrollArea.nativeElement.scrollHeight : 0;
    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (this.noteScrollArea &&
        this.noteScrollArea.nativeElement.scrollHeight - this.noteScrollArea.nativeElement.offsetHeight ===
          this.noteScrollArea.nativeElement.scrollTop) ||
      changes['customerServiceNotes']
    ) {
      setTimeout(() => {
        this.scrollHeight = this.noteScrollArea ? this.noteScrollArea.nativeElement.scrollHeight : 0;
        this.cd.detectChanges();
      });
    } else {
      this.newNotes = true;
    }
  }

  onSubmit() {
    const customerServiceNote = new CustomerServiceNote();
    customerServiceNote.text = this.newNoteForm.get('text').value;
    this.addNote.emit(customerServiceNote);
    this.newNoteForm.get('text').setValue('');
  }
}
